import React from "react";
import { connect } from "react-redux";
import { MESSAGE_SENDED } from "../constants/actionTypes";
import { LoanTypes, LoanStatuses, Dates, Credit } from "../constants/enums";
import { FormattedNumber, FormattedDate } from "react-intl";
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import MaterialDatePicker from './MaterialDatePicker';
import * as agent from "../agent";
import InnerLink from './InnerLink';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Preloader from './Preloader';
import theme from "../constants/theme";
const { yellow, white, lightYellow, red, black, grey, green, blueGrey } = theme.palette;
const statusStyles = { "ACTIVE": green, "TRADE": blueGrey, "PROBLEM": red, "BANKRUPT": black };
const extraLoanStatuses = { ...LoanStatuses, "PROBLEM": "Проблемный", "BANKRUPT": "Дефолт"}

const report6Row = ({ counterparty, sum, bodyDebt, percentsDebt, endDate }, i) => (
    <TableRow key={i}>
        <TableCell colSpan={3}>&nbsp;</TableCell>
        <TableCell>{(counterparty || "").toUpperCase()}</TableCell>
        <TableCell>
            <FormattedNumber value={sum}
                             style={`currency`}
                             currency="RUB"
                             minimumFractionDigits={0} />
        </TableCell>
        <TableCell>
            <FormattedNumber value={bodyDebt}
                             style={`currency`}
                             currency="RUB"
                             minimumFractionDigits={0} />
        </TableCell>
        <TableCell>
            <FormattedNumber value={percentsDebt}
                             style={`currency`}
                             currency="RUB"
                             minimumFractionDigits={0} />
        </TableCell>
        <TableCell>
            <FormattedDate value={new Date(endDate)}
                           day="numeric"
                           month="numeric"
                           year="numeric" />
        </TableCell>
    </TableRow>
)

class Reports2 extends React.Component {
    state = {
        companies: [],
        accountOrder: [],
        groups: [],
        subgroups: [],
        transactions: {},
        transactionsLoaded: false,
        openedSubgroups: [],
        openedPrograms: [],
        openedCounterparties: [],
        startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        endDate: new Date(),
        report2: {},
        report2Loaded: false,
        report3: {},
        report3Loaded: false,
        report4: [],
        report4Loaded: false,
        report5: [],
        report5Loaded: false,
        report6: {},
        report6Loaded: false,
        loading: false,
        statuses: ["ACTIVE", "TRADE", "PROBLEM", "BANKRUPT"],
        programs: Object.keys(LoanTypes).filter(t => t !== "NOT_SURE"),
        activeReport: null
    };
    componentDidMount = () => {
        this.fetchGroupedAccounts();
        this.fetchGroups();
        this.fetchSubgroups();
    }
    fireError = e => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: e.message, type: "error" } });
    fetchGroupedAccounts = () => {
        agent.Account.getGrouped()
            .then(res => this.setState({ companies: res, accountOrder: res.reduce((prev, { accounts }) => prev.concat(accounts.map(({ accountId }) => accountId)), [])}))
            .catch(this.fireError);
    }
    fetchGroups = () => {
        agent.OperationGroup.getAll()
            .then(res => this.setState({ groups: res }))
            .catch(this.fireError);
    }
    fetchSubgroups = () => {
        agent.OperationSubgroup.getAll()
            .then(res => this.setState({ subgroups: res }))
            .catch(this.fireError);
    }
    dropReports = () => {
        this.setState({ loading: true, transactionsLoaded: false, report2Loaded: false, report3Loaded: false, report4Loaded: false, report5Loaded: false, report6Loaded: false })
    }

    generateReport = () => {
        this.dropReports();
        const { startDate, endDate } = this.state;
        agent.Reports.generateReport(startDate.valueOf(), endDate.valueOf())
            .then(res => this.setState({
                transactions: res,
                transactionsLoaded: true,
                loading: false,
                activeReport: 1
            }))
            .catch(this.fireError);
    }
    generateReport2 = () => {
        this.dropReports();
        const { startDate, endDate } = this.state;
        agent.Reports.generateReport2(startDate.valueOf(), endDate.valueOf())
            .then(res => this.setState({
                report2: res,
                report2Loaded: true,
                loading: false,
                activeReport: 2
            }))
            .catch(this.fireError);
    }
    generateReport3 = () => {
        this.dropReports();
        const { startDate, endDate } = this.state;
        agent.Reports.generateReport3(startDate.valueOf(), endDate.valueOf())
            .then(res => this.setState({
                report3: res,
                report3Loaded: true,
                loading: false,
                activeReport: 3
            }))
            .catch(this.fireError);
    }
    generateReport4 = () => {
        this.dropReports();
        const { startDate, endDate } = this.state;
        agent.Reports.generateReport4(startDate.valueOf(), endDate.valueOf())
            .then(res => this.setState({
                report4: res,
                report4Loaded: true,
                loading: false,
                activeReport: 4
             }))
            .catch(this.fireError);
    }
    generateReport5 = () => {
        this.dropReports();
        agent.Reports.generateReport5()
            .then(res => this.setState({
                report5: res,
                report5Loaded:
                true,
                loading: false,
                activeReport: 5
            }))
            .catch(this.fireError);
    }
    generateReport6 = () => {
        this.dropReports();
        const { programs, statuses } = this.state;
        agent.Reports.generateReport6(programs, statuses)
            .then(res => this.setState({
                report6: res,
                report6Loaded: true,
                loading: false,
                activeReport: 6
             }))
            .catch(this.fireError);
    }
    toggleStatus = (status) => {
        const { statuses } = this.state;
        this.setState({ statuses: statuses.includes(status) ? statuses.filter(s => s !== status) : statuses.concat(status) }, () => this.generateReport6());
    }
    toggleProgramType = (program) => {
        const { programs } = this.state;
        this.setState({ programs: programs.includes(program) ? programs.filter(p => p !== program) : programs.concat(program) }, () => this.generateReport6());
    }
    toggleSubgroup = id => {
        const { openedSubgroups } = this.state;
        this.setState({ openedSubgroups: openedSubgroups.includes(id) ? openedSubgroups.filter(sg => sg !== id ) : openedSubgroups.concat(id) })
    }
    toggleProgram = program => {
        const { openedPrograms } = this.state;
        this.setState({ openedPrograms: openedPrograms.includes(program) ? openedPrograms.filter(p => p !== program ) : openedPrograms.concat(program) })
    }
    toggleCounterparty = counterparty => {
        const { openedCounterparties } = this.state;
        this.setState({ openedCounterparties: openedCounterparties.includes(counterparty) ? openedCounterparties.filter(c => c !== counterparty ) : openedCounterparties.concat(counterparty) })
    }
    onStartDateChange = date => this.setState({ startDate: new Date(date) });
    onEndDateChange = date => this.setState({ endDate: new Date(date) });

    render() {
        const { startDate,
                endDate,
                companies,
                transactions,
                groups,
                subgroups,
                transactionsLoaded,
                openedSubgroups,
                openedPrograms,
                openedCounterparties,
                accountOrder,
                statuses,
                programs,
                report2,
                report2Loaded,
                report3,
                report3Loaded,
                report4,
                report4Loaded,
                report5,
                report5Loaded,
                report6,
                report6Loaded,
                activeReport,
                loading } = this.state;

        const { previousPeriod, currentPeriod, endPeriod } = transactions;
        const { total, deniedTotal, deniedByClient, deniedByManager, signedContracts } = report2;
        const { contracts = {}, credits = {} } = report6;

        const report6ContractsSummary = Object.keys(contracts).reduce((acc, program) => ({
            sum: acc.sum + contracts[program].sum,
            bodyDebt: acc.bodyDebt + contracts[program].bodyDebt,
            percentsDebt: acc.percentsDebt + contracts[program].percentsDebt
        }), {sum: 0, bodyDebt: 0, percentsDebt: 0});
        const report6CreditsSummary = Object.keys(credits).reduce((acc, program) => ({
            sum: acc.sum + credits[program].sum,
            bodyDebt: acc.bodyDebt + credits[program].bodyDebt,
            percentsDebt: acc.percentsDebt + credits[program].percentsDebt
        }), {sum: 0, bodyDebt: 0, percentsDebt: 0});

        return (
            <div style={{ overflow: "hidden" }}>
                <Grid container direction="column" justify="flex-start" spacing={16}>
                    <Grid item xs>
                        <Grid container alignItems="center" justify="center" spacing={8}>
                            <Grid item>
                                <Button type="submit"
                                        onClick={this.generateReport}
                                        size="large"
                                        color="primary"
                                        variant="contained">Отчет 1</Button>
                            </Grid>
                            <Grid item>
                                <Button type="submit"
                                        onClick={this.generateReport2}
                                        size="large"
                                        color="primary"
                                        variant="contained">Отчет 2</Button>
                            </Grid>
                            <Grid item>
                                <Button type="submit"
                                        onClick={this.generateReport3}
                                        size="large"
                                        color="primary"
                                        variant="contained">Отчет 3</Button>
                            </Grid>
                            <Grid item>
                                <Button type="submit"
                                        onClick={this.generateReport4}
                                        size="large"
                                        color="primary"
                                        variant="contained">Обороты по счетам</Button>
                            </Grid>
                            <Grid item>
                                <Button type="submit"
                                        onClick={this.generateReport5}
                                        size="large"
                                        color="primary"
                                        variant="contained">Инвестиционный портфель</Button>
                            </Grid>
                            <Grid item>
                                <Button type="submit"
                                        onClick={this.generateReport6}
                                        size="large"
                                        color="primary"
                                        variant="contained">Кредитный портфель</Button>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs>
                        <Grid container alignItems="center" justify="center" spacing={16}>
                            {[1,2,3,4].includes(activeReport) &&
                                <Grid item>
                                    <MaterialDatePicker label="Начало периода" value={startDate} onChange={this.onStartDateChange} />
                                </Grid>
                            }
                            {[1,2,3,4].includes(activeReport) &&
                                <Grid item>
                                    <MaterialDatePicker label="Конец периода" value={endDate} onChange={this.onEndDateChange} />
                                </Grid>
                            }
                            {6 === activeReport &&
                                ["ACTIVE", "TRADE", "PROBLEM", "BANKRUPT"].map((s, i) =>
                                    <Grid key={s} item>
                                        <Button style={ statuses.includes(s) ? statusStyles[s] : white }
                                                variant="contained"
                                                onClick={() => this.toggleStatus(s)}>
                                            {extraLoanStatuses[s]}
                                        </Button>
                                    </Grid>
                                )
                            }
                            {6 === activeReport &&
                                Object.keys(LoanTypes).filter(t => t !== "NOT_SURE").map((t, i) =>
                                    <Grid key={t} item>
                                        <Button onClick={() => this.toggleProgramType(t)}
                                                variant={programs.includes(t) ? "contained" : "outlined"}>
                                            {LoanTypes[t]}
                                        </Button>
                                    </Grid>
                            )}
                        </Grid>
                    </Grid>
                </Grid>
                { loading && <Preloader /> }
                {report6Loaded &&
                    <Table padding="checkbox">
                        <TableHead>
                            <TableRow>
                                <TableCell>Тип</TableCell>
                                <TableCell>Программа</TableCell>
                                <TableCell>Статус</TableCell>
                                <TableCell>Контрагент</TableCell>
                                <TableCell>Сумма</TableCell>
                                <TableCell>Долг по телу</TableCell>
                                <TableCell>Долг по процентам</TableCell>
                                <TableCell>Дата окончания</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow style={ { backgroundColor: "#fdd835" }}>
                                <TableCell>Операционные займы</TableCell>
                                <TableCell colSpan={3}>&nbsp;</TableCell>
                                <TableCell>
                                    <FormattedNumber value={report6ContractsSummary.sum}
                                                     style={`currency`}
                                                     currency="RUB"
                                                     minimumFractionDigits={0} />
                                </TableCell>
                                <TableCell>
                                    <FormattedNumber value={report6ContractsSummary.bodyDebt}
                                                     style={`currency`}
                                                     currency="RUB"
                                                     minimumFractionDigits={0} />
                                </TableCell>
                                <TableCell>
                                    <FormattedNumber value={report6ContractsSummary.percentsDebt}
                                                     style={`currency`}
                                                     currency="RUB"
                                                     minimumFractionDigits={0} />
                                </TableCell>
                                <TableCell>&nbsp;</TableCell>
                            </TableRow>
                            {Object.keys(contracts).filter(program => programs.includes(program.toUpperCase())).map((program, i) => (
                                <React.Fragment key={program}>
                                    <TableRow style={Object.assign({ cursor: "pointer" }, yellow)}
                                              onClick={() => this.toggleProgram(program)}>
                                              <TableCell>&nbsp;</TableCell>
                                              <TableCell colSpan={3}>{Object.assign({}, LoanTypes)[program.toUpperCase()]}</TableCell>
                                              <TableCell>
                                                  <FormattedNumber value={contracts[program].sum}
                                                                   style={`currency`}
                                                                   currency="RUB"
                                                                   minimumFractionDigits={0} />
                                              </TableCell>
                                              <TableCell>
                                                  <FormattedNumber value={contracts[program].bodyDebt}
                                                                   style={`currency`}
                                                                   currency="RUB"
                                                                   minimumFractionDigits={0} />
                                              </TableCell>
                                              <TableCell>
                                                  <FormattedNumber value={contracts[program].percentsDebt}
                                                                   style={`currency`}
                                                                   currency="RUB"
                                                                   minimumFractionDigits={0} />
                                              </TableCell>
                                              <TableCell colSpan={2}>&nbsp;</TableCell>
                                    </TableRow>
                                    {openedPrograms.includes(program) && (Object.keys(contracts[program].statuses) || []).filter(status => statuses.includes(status.toUpperCase())).map((status, i) => (
                                        <React.Fragment key={status}>
                                            <TableRow style={Object.assign({ cursor: "pointer" }, lightYellow)}>
                                                      <TableCell colSpan={2}>&nbsp;</TableCell>
                                                      <TableCell colSpan={2}>{extraLoanStatuses[status.toUpperCase()]}</TableCell>
                                                      <TableCell>
                                                          <FormattedNumber value={contracts[program].statuses[status].sum}
                                                                           style={`currency`}
                                                                           currency="RUB"
                                                                           minimumFractionDigits={0} />
                                                      </TableCell>
                                                      <TableCell>
                                                          <FormattedNumber value={contracts[program].statuses[status].bodyDebt}
                                                                           style={`currency`}
                                                                           currency="RUB"
                                                                           minimumFractionDigits={0} />
                                                      </TableCell>
                                                      <TableCell>
                                                          <FormattedNumber value={contracts[program].statuses[status].percentsDebt}
                                                                           style={`currency`}
                                                                           currency="RUB"
                                                                           minimumFractionDigits={0} />
                                                      </TableCell>
                                                      <TableCell>&nbsp;</TableCell>
                                            </TableRow>
                                            {openedPrograms.includes(program) && (contracts[program].statuses[status].entries || []).map(report6Row)}
                                        </React.Fragment>
                                    ))}
                                </React.Fragment>
                            ))}
                            <TableRow style={ { backgroundColor: "#fdd835" }}>
                                <TableCell>Неоперационные займы</TableCell>
                                <TableCell colSpan={3}>&nbsp;</TableCell>
                                <TableCell>
                                    <FormattedNumber value={report6CreditsSummary.sum}
                                                     style={`currency`}
                                                     currency="RUB"
                                                     minimumFractionDigits={0} />
                                </TableCell>
                                <TableCell>
                                    <FormattedNumber value={report6CreditsSummary.bodyDebt}
                                                     style={`currency`}
                                                     currency="RUB"
                                                     minimumFractionDigits={0} />
                                </TableCell>
                                <TableCell>
                                    <FormattedNumber value={report6CreditsSummary.percentsDebt}
                                                     style={`currency`}
                                                     currency="RUB"
                                                     minimumFractionDigits={0} />
                                </TableCell>
                                <TableCell>&nbsp;</TableCell>
                            </TableRow>
                            {Object.keys(credits).map((program, i) => (
                                <React.Fragment key={i}>
                                    <TableRow style={Object.assign({ cursor: "pointer" }, yellow)}
                                              onClick={() => this.toggleProgram(program)}>
                                              <TableCell>&nbsp;</TableCell>
                                              <TableCell colSpan={2}>{Object.assign({}, Credit.Types)[program.toUpperCase()]}</TableCell>
                                              <TableCell>
                                                  <FormattedNumber value={credits[program].sum}
                                                                   style={`currency`}
                                                                   currency="RUB"
                                                                   minimumFractionDigits={0} />
                                              </TableCell>
                                              <TableCell>
                                                  <FormattedNumber value={credits[program].bodyDebt}
                                                                   style={`currency`}
                                                                   currency="RUB"
                                                                   minimumFractionDigits={0} />
                                              </TableCell>
                                              <TableCell>
                                                  <FormattedNumber value={credits[program].percentsDebt}
                                                                   style={`currency`}
                                                                   currency="RUB"
                                                                   minimumFractionDigits={0} />
                                              </TableCell>
                                              <TableCell colSpan={2}>&nbsp;</TableCell>
                                    </TableRow>
                                    {openedPrograms.includes(program) && (credits[program].entries || []).map(report6Row)}
                                </React.Fragment>
                            ))}
                            <TableRow style={grey}>
                                <TableCell colSpan={4}>Итого:</TableCell>
                                <TableCell>
                                    <FormattedNumber value={report6ContractsSummary.sum + report6CreditsSummary.sum}
                                                     style={`currency`}
                                                     currency="RUB"
                                                     minimumFractionDigits={0} />
                                </TableCell>
                                <TableCell>
                                    <FormattedNumber value={report6ContractsSummary.bodyDebt + report6CreditsSummary.bodyDebt}
                                                     style={`currency`}
                                                     currency="RUB"
                                                     minimumFractionDigits={0} />
                                </TableCell>
                                <TableCell>
                                    <FormattedNumber value={report6ContractsSummary.percentsDebt + report6CreditsSummary.percentsDebt}
                                                     style={`currency`}
                                                     currency="RUB"
                                                     minimumFractionDigits={0} />
                                </TableCell>
                                <TableCell colSpan={2}>&nbsp;</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                }
                {report5Loaded &&
                    <Table padding="checkbox">
                        <TableHead>
                            <TableRow>
                                <TableCell>Вид займа</TableCell>
                                <TableCell>Контрагент</TableCell>
                                <TableCell>Договор</TableCell>
                                <TableCell>Компания</TableCell>
                                <TableCell>Сумма договора</TableCell>
                                <TableCell>Процентная ставка</TableCell>
                                <TableCell>Долг по телу займа</TableCell>
                                <TableCell>Долг по процентам</TableCell>
                                <TableCell>Дата окончания</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {Object.keys(report5).map((t, i) =>
                                <React.Fragment key={i}>
                                    <TableRow style={yellow}>
                                        <TableCell>
                                            {Credit.Types[t]}
                                        </TableCell>
                                        <TableCell colSpan={5}>
                                            &nbsp;
                                        </TableCell>
                                        <TableCell >
                                            <FormattedNumber value={report5[t].sumDebt}
                                                             style={`currency`}
                                                             currency="RUB"
                                                             minimumFractionDigits={0} />
                                        </TableCell>
                                        <TableCell >
                                            <FormattedNumber value={report5[t].percentsDebt}
                                                             style={`currency`}
                                                             currency="RUB"
                                                             minimumFractionDigits={0} />
                                        </TableCell>
                                        <TableCell>
                                            &nbsp;
                                        </TableCell>
                                    </TableRow>
                                    {Object.keys(report5[t].counterparties).map((counterpartyId, j) => {
                                        const { entries, name, sumDebt, percentsDebt } = report5[t].counterparties[counterpartyId];

                                        return (
                                            <React.Fragment key={j}>
                                                <TableRow style={Object.assign({ cursor: "pointer" }, lightYellow)} onClick={() => this.toggleCounterparty(counterpartyId)}>
                                                    <TableCell>&nbsp;</TableCell>
                                                    <TableCell>{name}</TableCell>
                                                    <TableCell colSpan={4}>&nbsp;</TableCell>
                                                    <TableCell>
                                                        <FormattedNumber value={sumDebt}
                                                                         style={`currency`}
                                                                         currency="RUB"
                                                                         minimumFractionDigits={0} />
                                                    </TableCell>
                                                    <TableCell>
                                                        <FormattedNumber value={percentsDebt}
                                                                         style={`currency`}
                                                                         currency="RUB"
                                                                         minimumFractionDigits={0} />
                                                    </TableCell>
                                                    <TableCell>&nbsp;</TableCell>
                                                </TableRow>
                                                {openedCounterparties.includes(counterpartyId) &&
                                                    entries.map(({ date, company, duration, sum, percentsDebt, rate, number, _id }, k ) => (
                                                        <TableRow key={k}>
                                                            <TableCell colSpan={2}>
                                                                &nbsp;
                                                            </TableCell>
                                                            <TableCell>
                                                                <InnerLink href={`/credit/${_id}`} label={("0".repeat(6) + number).slice(-6)} />
                                                            </TableCell>
                                                            <TableCell>
                                                                {company}
                                                            </TableCell>
                                                            <TableCell>
                                                                <FormattedNumber value={sum}
                                                                                 style={`currency`}
                                                                                 currency="RUB"
                                                                                 minimumFractionDigits={0} />
                                                            </TableCell>
                                                            <TableCell>
                                                                {rate}
                                                            </TableCell>
                                                            <TableCell>
                                                                <FormattedNumber value={sum}
                                                                                 style={`currency`}
                                                                                 currency="RUB"
                                                                                 minimumFractionDigits={0} />
                                                            </TableCell>
                                                            <TableCell>
                                                                <FormattedNumber value={percentsDebt}
                                                                                 style={`currency`}
                                                                                 currency="RUB"
                                                                                 minimumFractionDigits={0} />
                                                            </TableCell>
                                                            <TableCell>
                                                                <FormattedDate value={new Date(+new Date(date) + duration * Dates._1Day)}
                                                                               day="numeric"
                                                                               month="numeric"
                                                                               year="numeric" />
                                                            </TableCell>
                                                        </TableRow>
                                                    )
                                                )}
                                            </React.Fragment>
                                        )
                                    })}
                                </React.Fragment>
                            )}
                        </TableBody>
                    </Table>
                }
                {report4Loaded &&
                    <Table padding="checkbox">
                        <TableHead>
                            <TableRow>
                                <TableCell>Учетный счет</TableCell>
                                <TableCell>Начало периода</TableCell>
                                <TableCell>Приход</TableCell>
                                <TableCell>Расход</TableCell>
                                <TableCell>Конец периода</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {report4.map(( { _id, previousPeriod, currentPeriodDebit, currentPeriodCredit, endPeriod }, i) =>
                                <TableRow key={i}>
                                    <TableCell>{ _id }</TableCell>
                                    <TableCell>
                                        <FormattedNumber value={previousPeriod}
                                                         style={`currency`}
                                                         currency="RUB"
                                                         minimumFractionDigits={0} />
                                    </TableCell>
                                    <TableCell>
                                        <FormattedNumber value={currentPeriodDebit}
                                                         style={`currency`}
                                                         currency="RUB"
                                                         minimumFractionDigits={0} />
                                    </TableCell>
                                    <TableCell>
                                        <FormattedNumber value={currentPeriodCredit}
                                                         style={`currency`}
                                                         currency="RUB"
                                                         minimumFractionDigits={0} />
                                    </TableCell>
                                    <TableCell>
                                        <FormattedNumber value={endPeriod}
                                                         style={`currency`}
                                                         currency="RUB"
                                                         minimumFractionDigits={0} />
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                }
                {report3Loaded &&
                    <Table padding="checkbox">
                        <TableBody>
                            <TableRow>
                                <TableCell>&nbsp;</TableCell>
                                <TableCell style={yellow}>Всего</TableCell>
                                <TableCell colSpan={Object.keys(report3.byProgram).length}>По программам</TableCell>
                                <TableCell colSpan={Object.keys(report3.byOffice).length}>По офисам</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>&nbsp;</TableCell>
                                <TableCell style={yellow}>&nbsp;</TableCell>
                                {Object.keys(report3.byProgram).map(p => <TableCell>{LoanTypes[p]}</TableCell>)}
                                {Object.keys(report3.byOffice).map(o => <TableCell>{({"NEWCHERKASSKY": "НВЧ", "MOSCOW": "МСК"})[o]}</TableCell>)}
                            </TableRow >
                            <TableRow>
                                <TableCell>Активные договоры</TableCell>
                                <TableCell style={yellow}>{report3.total}</TableCell>
                                {Object.keys(report3.byProgram).map(p => <TableCell>{report3.byProgram[p]}</TableCell>)}
                                {Object.keys(report3.byOffice).map(o => <TableCell>{report3.byOffice[o]}</TableCell>)}
                            </TableRow >
                        </TableBody>
                    </Table>
                }
                {report2Loaded &&
                    <Table padding="checkbox">
                        <TableHead>
                            <TableRow >
                                <TableCell>Подано заявок</TableCell>
                                <TableCell>Отказано</TableCell>
                                <TableCell>Выдано займов</TableCell>
                            </TableRow >
                        </TableHead>
                        <TableBody>
                            <TableRow style={yellow}>
                                <TableCell>{total || 0}</TableCell>
                                <TableCell>{deniedTotal || 0} = {deniedByManager || 0} (источник - Менеджер) + {deniedByClient || 0} (источник - Клиент)</TableCell>
                                <TableCell>{signedContracts || 0}</TableCell>
                            </TableRow >
                            <TableRow>
                                <TableCell colSpan={3}>* До 13.12 дата отказа в займе не фиксировалась, в столбец "Отказано" они не попадут. Возможное решение: добавить во все заявки с отказом дату отказа, равную дате создания</TableCell>
                            </TableRow >
                        </TableBody>
                    </Table>
                }
                {transactionsLoaded &&
                    <Table padding="checkbox">
                        <TableBody>
                            <TableRow >
                                <TableCell>&nbsp;</TableCell>
                                {companies.map(({ _id : { companyName } = {}, accounts }, i) => <TableCell key={i} colSpan={accounts.length}>{companyName}</TableCell>)}
                            </TableRow >
                            <TableRow >
                                <TableCell>&nbsp;</TableCell>
                                {companies.map(({ accounts }) => {
                                    return accounts.map(({ accountName }, j) => <TableCell key={j}>{accountName}</TableCell>)
                                })}
                            </TableRow >
                            <TableRow style={grey}>
                                <TableCell>Остаток денежных средств на начало периода</TableCell>
                                {accountOrder.map((accountId, k) => (
                                    <TableCell key={k}>
                                        { accountId in previousPeriod ?
                                            <FormattedNumber value={previousPeriod[accountId]}
                                                             style={`currency`}
                                                             currency="RUB"
                                                             minimumFractionDigits={0} />
                                            :
                                            0
                                        }
                                    </TableCell>
                                ))}
                            </TableRow >
                            {Object.keys(currentPeriod).map((group, l) => {
                                const foundedGroup = groups.find(g => g._id === group) || {};
                                return (
                                    <React.Fragment>
                                        <TableRow key={l} style={yellow}>
                                            <TableCell>{foundedGroup.name}</TableCell>
                                            {accountOrder.map((accountId, n) => (
                                                <TableCell key={n}>
                                                    { accountId in currentPeriod[group].accounts ?
                                                        <FormattedNumber value={currentPeriod[group].accounts[accountId]}
                                                                         style={`currency`}
                                                                         currency="RUB"
                                                                         minimumFractionDigits={0} />
                                                        :
                                                        0
                                                    }
                                                </TableCell>
                                            ))}
                                        </TableRow >
                                        {Object.keys(currentPeriod[group].subgroups).map((subgroupId, m) => {
                                            const foundedSubgroup = subgroups.find(sg => sg._id === subgroupId) || {};
                                            return (
                                                <React.Fragment key={l}>
                                                    <TableRow style={Object.assign({ cursor: "pointer" }, lightYellow)} onClick={() => this.toggleSubgroup(subgroupId)}>
                                                        <TableCell>{foundedSubgroup.name}</TableCell>
                                                        {accountOrder.map((accountId, n) => {
                                                            const sg = currentPeriod[group].subgroups[subgroupId] || {};
                                                            return (
                                                                <TableCell key={n}>
                                                                    { accountId in sg.accounts ?
                                                                        <FormattedNumber value={sg.accounts[accountId]}
                                                                                         style={`currency`}
                                                                                         currency="RUB"
                                                                                         minimumFractionDigits={0} />
                                                                        : 0
                                                                    }
                                                                </TableCell>
                                                            )
                                                        })}
                                                    </TableRow >
                                                    {openedSubgroups.includes(subgroupId) &&
                                                        Object.keys(currentPeriod[group].subgroups[subgroupId].operations).map((operationId, m) => {
                                                            return (
                                                                <TableRow key={m}>
                                                                    <TableCell>{currentPeriod[group].subgroups[subgroupId].operations[operationId].name}</TableCell>
                                                                    {accountOrder.map((accountId, n) => (
                                                                        <TableCell key={n}>
                                                                            { accountId in currentPeriod[group].subgroups[subgroupId].operations[operationId] ?
                                                                                <FormattedNumber value={currentPeriod[group].subgroups[subgroupId].operations[operationId][accountId]}
                                                                                                 style={`currency`}
                                                                                                 currency="RUB"
                                                                                                 minimumFractionDigits={0} />
                                                                                :
                                                                                0
                                                                            }
                                                                        </TableCell>
                                                                    ))}
                                                                </TableRow >
                                                            )
                                                        }
                                                    )}
                                                </React.Fragment>
                                            )
                                        })}
                                    </React.Fragment>
                                );
                            })}
                            <TableRow style={grey}>
                                <TableCell>Остаток денежных средств на конец периода</TableCell>
                                {accountOrder.map((accountId, i) => (
                                    <TableCell key={i}>
                                        { accountId in endPeriod ?
                                            <FormattedNumber value={endPeriod[accountId]}
                                                             style={`currency`}
                                                             currency="RUB"
                                                             minimumFractionDigits={0} />
                                            :
                                            0
                                        }
                                    </TableCell>
                                ))}
                            </TableRow >
                        </TableBody >
                    </Table>
                }
            </div>
        )
    }
}

export default connect(null, null)(Reports2);



// WEBPACK FOOTER //
// ./src/components/Reports2.js